/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var lang_1 = require('../facade/lang');
var exceptions_1 = require('../facade/exceptions');
var platform_location_1 = require('./platform_location');
var location_strategy_1 = require('./location_strategy');
var location_1 = require('./location');
var PathLocationStrategy = (function(_super) {
  __extends(PathLocationStrategy, _super);
  function PathLocationStrategy(_platformLocation, href) {
    _super.call(this);
    this._platformLocation = _platformLocation;
    if (lang_1.isBlank(href)) {
      href = this._platformLocation.getBaseHrefFromDOM();
    }
    if (lang_1.isBlank(href)) {
      throw new exceptions_1.BaseException("No base href set. Please provide a value for the APP_BASE_HREF token or add a base element to the document.");
    }
    this._baseHref = href;
  }
  PathLocationStrategy.prototype.onPopState = function(fn) {
    this._platformLocation.onPopState(fn);
    this._platformLocation.onHashChange(fn);
  };
  PathLocationStrategy.prototype.getBaseHref = function() {
    return this._baseHref;
  };
  PathLocationStrategy.prototype.prepareExternalUrl = function(internal) {
    return location_1.Location.joinWithSlash(this._baseHref, internal);
  };
  PathLocationStrategy.prototype.path = function() {
    return this._platformLocation.pathname + location_1.Location.normalizeQueryParams(this._platformLocation.search);
  };
  PathLocationStrategy.prototype.pushState = function(state, title, url, queryParams) {
    var externalUrl = this.prepareExternalUrl(url + location_1.Location.normalizeQueryParams(queryParams));
    this._platformLocation.pushState(state, title, externalUrl);
  };
  PathLocationStrategy.prototype.replaceState = function(state, title, url, queryParams) {
    var externalUrl = this.prepareExternalUrl(url + location_1.Location.normalizeQueryParams(queryParams));
    this._platformLocation.replaceState(state, title, externalUrl);
  };
  PathLocationStrategy.prototype.forward = function() {
    this._platformLocation.forward();
  };
  PathLocationStrategy.prototype.back = function() {
    this._platformLocation.back();
  };
  PathLocationStrategy.decorators = [{type: core_1.Injectable}];
  PathLocationStrategy.ctorParameters = [{type: platform_location_1.PlatformLocation}, {
    type: undefined,
    decorators: [{type: core_1.Optional}, {
      type: core_1.Inject,
      args: [location_strategy_1.APP_BASE_HREF]
    }]
  }];
  return PathLocationStrategy;
}(location_strategy_1.LocationStrategy));
exports.PathLocationStrategy = PathLocationStrategy;
